'use strict';

function MapRegistry (MapActions, MapStore, MapStrings, MapWrapper) {
  
  var actions = {};
  var stores = {};
  var wrappers = {};

  return {

    getActions: function getActions (mapId) {
      return actions[mapId];
    },
  
    getStore: function getStore (mapId) {
      return stores[mapId];
    },

    getWrapper: function (mapId) {
      return wrappers[mapId];
    },

    register: function register (mapId) {
      var action, store, wrapper;
      
      action = actions[mapId] = MapActions.create(mapId);
      store = stores[mapId] = MapStore.create(mapId);
      wrapper = wrappers[mapId] = MapWrapper.create(mapId);
      
      return {
        actions: action,
        store: store,
        wrapper: wrapper
      };
    },

    languageChanged: function languageChanged () {
      MapStrings.refreshStrings();
    }
  };
}

MapRegistry.$inject = ['sbMapActions', 'sbMapStore', 'sbMapStrings', 'sbMapWrapper'];
module.exports = MapRegistry;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/MapRegistry.js